import { Injectable, inject } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogData } from '../../../components/dialogs/confirm-dialog/confirm-dialog.component';
import { MarkAllOfficialDialogComponent, MarkAllOfficialDialogData } from '../../../components/dialogs/mark-all-official-dialog/mark-all-official-dialog.component';
import { RestoreDatabaseDialogComponent, RestoreDatabaseDialogData } from '../../../components/dialogs/restore-database-dialog/restore-database-dialog.component';
import { DatabaseRestoreOptions } from '../../../models/simulator.models';

export type ConfirmDialogOptions = Omit<ConfirmDialogData, 'message'>;

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private readonly dialog = inject(Dialog);

  async confirm(message: string, options?: ConfirmDialogOptions): Promise<boolean> {
    const dialogRef = this.dialog.open<boolean>(ConfirmDialogComponent, {
      data: { ...options, message },
      disableClose: true,
      panelClass: 'confirm-dialog-panel'
    });

    const result = await firstValueFrom(dialogRef.closed);
    return result ?? false;
  }

  async confirmMarkAllOfficial(data: MarkAllOfficialDialogData): Promise<boolean> {
    const dialogRef = this.dialog.open<boolean>(MarkAllOfficialDialogComponent, {
      data,
      disableClose: true,
      panelClass: 'mark-all-official-dialog-panel',
      backdropClass: 'mark-all-official-dialog-backdrop',
      width: '640px',
      maxWidth: '95vw'
    });

    const result = await firstValueFrom(dialogRef.closed);
    return result ?? false;
  }

  async confirmRestoreDatabase(data: RestoreDatabaseDialogData): Promise<DatabaseRestoreOptions | null> {
    const dialogRef = this.dialog.open<DatabaseRestoreOptions | null>(RestoreDatabaseDialogComponent, {
      data,
      disableClose: true,
      panelClass: 'restore-database-dialog-panel'
    });

    return await firstValueFrom(dialogRef.closed) ?? null;
  }
}
